'use client';

import createSvg from '~/public/static/svg/createSvg';

export const Zamboni = createSvg(props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="456"
    height="133"
    fill="none"
    {...props}
  >
    <ellipse cx="228" cy="109.5" fill="#F2FCF8" rx="228" ry="23.5" />
    <path
      fill="#fff"
      d="M165.097 71.291h20.456l-17.602 22.835h-20.456l17.602-22.835Z"
    />
    <path
      stroke="#02C874"
      strokeWidth="2"
      d="M165.097 71.291h20.456l-17.602 22.835h-20.456l17.602-22.835Z"
    />
    <path
      stroke="#02C874"
      strokeWidth="2"
      d="M165.097 71.291h20.456l-17.602 22.835h-20.456l17.602-22.835ZM188 21.4c0-5.677 4.72-10.215 10.392-9.992l112.804 4.425A5 5 0 0 1 316 20.83v21.258L188 55V21.4Z"
    />
    <path
      stroke="#02C874"
      strokeWidth="2"
      d="M188 21.4c0-5.677 4.72-10.215 10.392-9.992l112.804 4.425A5 5 0 0 1 316 20.83v21.258L188 55V21.4Z"
    />
    <path
      stroke="#02C874"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M311.146 85.563 188 86V54.5L311.146 43v42.563Z"
    />
    <path
      stroke="#02C874"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M311.146 85.563 188 86V54.5L311.146 43v42.563Z"
    />
    <path fill="#fff" d="M139 20h17.199v16.808H188V85.5l-49-30.198V20Z" />
    <path
      stroke="#02C874"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M139 20h17.199v16.808H188V85.5l-49-30.198V20Z"
    />
    <path
      stroke="#02C874"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M139 20h17.199v16.808H188V85.5l-49-30.198V20Z"
    />
    <path
      stroke="#02C874"
      strokeWidth="2"
      d="m189.466 16.846-14.912-9.408m14.912 9.408-14.912-9.408"
    />
    <path
      stroke="#02C874"
      strokeLinecap="round"
      strokeWidth="2"
      d="m170.634 13.13 6.792-11.764m-6.792 11.764 6.792-11.764"
    />
    <path fill="#fff" d="M188.408 78.427H314v8.563H188.408z" />
    <path
      stroke="#02C874"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M188.408 78.427H314v8.563H188.408z"
    />
    <path
      stroke="#02C874"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M188.408 78.427H314v8.563H188.408z"
    />
    <circle cx="292.117" cy="88.893" r="16.175" fill="#fff" />
    <circle
      cx="292.117"
      cy="88.893"
      r="16.175"
      stroke="#02C874"
      strokeWidth="2"
    />
    <circle
      cx="292.117"
      cy="88.893"
      r="16.175"
      stroke="#02C874"
      strokeWidth="2"
    />
    <circle cx="201.728" cy="88.893" r="16.175" fill="#fff" />
    <circle
      cx="201.728"
      cy="88.893"
      r="16.175"
      stroke="#02C874"
      strokeWidth="2"
    />
    <circle
      cx="201.728"
      cy="88.893"
      r="16.175"
      stroke="#02C874"
      strokeWidth="2"
    />
    <circle cx="292.117" cy="88.893" r="8.087" fill="#fff" />
    <circle
      cx="292.117"
      cy="88.893"
      r="8.087"
      stroke="#02C874"
      strokeWidth="2"
    />
    <circle
      cx="292.117"
      cy="88.893"
      r="8.087"
      stroke="#02C874"
      strokeWidth="2"
    />
    <circle cx="201.728" cy="88.893" r="8.087" fill="#fff" />
    <circle
      cx="201.728"
      cy="88.893"
      r="8.087"
      stroke="#02C874"
      strokeWidth="2"
    />
    <circle
      cx="201.728"
      cy="88.893"
      r="8.087"
      stroke="#02C874"
      strokeWidth="2"
    />
    <path
      fill="#fff"
      d="M124.66 89.369h39.961l15.699 15.699H118v-8.087l6.66-7.612Z"
    />
    <path
      stroke="#02C874"
      strokeWidth="2"
      d="M124.66 89.369h39.961l15.699 15.699H118v-8.087l6.66-7.612Z"
    />
    <path
      stroke="#02C874"
      strokeWidth="2"
      d="M124.66 89.369h39.961l15.699 15.699H118v-8.087l6.66-7.612Z"
    />
  </svg>
));
